import React, { useEffect, useLayoutEffect, useState } from "react";
import axios from "axios";
import { FaFilter, FaRegEye, FaSearch } from "react-icons/fa";
import { BsListTask } from "react-icons/bs";
import { MdOutlineAssignmentInd, MdOutlineDeleteOutline } from "react-icons/md";
import { TiEdit } from "react-icons/ti";
import { RiArrowDownSLine, RiRadioButtonLine } from "react-icons/ri";
import CreateTask from "Components/Admin-Components/Tasks/CreateTask";
import EditTask from "Components/Admin-Components/Tasks/EditTask";
import AssignStaff from "Components/Admin-Components/Tasks/AssignStaff";
import StartTask from "Components/Admin-Components/Tasks/StartTask";
import EndTask from "Components/Admin-Components/Tasks/EndTask";
import ConfirmDeleteModal from "Components/Admin-Components/Common Modals/ConfirmDeleteModal";
import toast from "react-hot-toast";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";

import TaskUpdates from "Components/Admin-Components/Tasks/TaskUpdates";

function Task() {
  const [loading, setLoading] = useState(false); //State for loader
  const [selectedTask, setSelectedTask] = useState({}); //State for selected task
  const [openFilterDropDown, setOpenFilterDropDown] = useState(false);

  //States for opening different modals (For Admin Use)
  const [createTaskModalOpen, setCreateTaskModalOpen] = useState(false);
  const [editTaskModalOpen, setEditTaskModalOpen] = useState(false);
  const [assignStaffModalOpen, setAssignStaffModalOpen] = useState(false);
  const [viewTaskDetails, setViewTaskDetails] = useState(false);
  const [deleteModalOpen, setdeleteModalOpen] = useState(false);

  //States for opening different modals (For Staff Use)
  const [startTaskModalOpen, setStartTaskModalOpen] = useState(false);
  const [endTaskModalOpen, setEndTaskModalOpen] = useState(false);
  const [tasks, setTasks] = useState([]); //State for all tasks
  const [allCategories, setAllCategories] = useState([]); //State for storing all categories

  //States for filters
  const [status, setStatus] = useState("");
  const [category, setCategory] = useState("");
  const [priority, setPriority] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false); //State to trigger getAllTasks whenever a filter is applied or removed
  const [filteredTasks, setFilteredTasks] = useState([]);

  //State for pagination
  const [currentPage, setCurrentPage] = useState(1);

  //Fetching user details from the local storage
  const storedData = localStorage.getItem("Ananya Enterprize-Users-Data");

  //Converting the fetched user details into JSON
  const userData = storedData ? JSON.parse(storedData) : {};
  const role = userData?.role;

  //Function to get all the tasks
  const getAllTasks = () => {
    setLoading(true);

    //Constructing a query parameter
    const queryParams = new URLSearchParams({
      staffId: userData._id,
      status: status || "",
      priority: priority || "",
      category: category || "",
      startDate: startDate || "",
    }).toString();

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/task/get-all-tasks/?${queryParams}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllTasks: ", response.data);
        setTasks(response.data.tasks);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in getAllTasks: ", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllTasks();
  }, [isFiltersApplied, category, startDate]);

  //Function to delete a task
  const deleteTask = (taskId) => {
    setLoading(true);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/task/delete-task/${taskId}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of deleteTask: ", response.data);
        setLoading(false);
        setdeleteModalOpen(false);
        getAllTasks();
        toast.success(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Function to get all the categories
  const getAllCategories = () => {
    setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/category/get-all-categories`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllCategories: ", response.data);
        setAllCategories(response.data.categories);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in fetching all categories: ", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  //Function to handle edit click
  const handleEditClick = (task) => {
    setSelectedTask(task);
    setEditTaskModalOpen(true);
  };

  //Function to handle click assign staff
  const handleAssignStaffClick = (task) => {
    setSelectedTask(task);
    setAssignStaffModalOpen(true);
  };

  //Function to handle Start Task button click
  const handleStartTaskClick = (task) => {
    setSelectedTask(task);
    setStartTaskModalOpen(true);
  };

  //Function to handle End Task button click
  const handleEndTaskClick = (task) => {
    setSelectedTask(task);
    setEndTaskModalOpen(true);
  };

  //Function to handle delete click
  const handleDeleteClick = (task) => {
    setSelectedTask(task);
    setdeleteModalOpen(true);
  };

  //Function to handle view task click
  const handleViewTask = (task) => {
    setSelectedTask(task);
    setViewTaskDetails(true);
  };

  //Function to toggle the filter dropdown
  const toggleFilterDropDown = () => {
    setOpenFilterDropDown(!openFilterDropDown);
  };

  //Function to clear all filters
  const clearFilters = () => {
    setIsFiltersApplied(!isFiltersApplied);
    setStatus("");
    setCategory("");
    setPriority("");
    setStartDate("");
    setSearchTerm("");
    setOpenFilterDropDown(false);
  };

  useEffect(() => {
    const filteredTasks = tasks?.filter((task) => {
      const matchesSearch =
        task.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        task.staffAssigned?.name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
      return matchesSearch;
    });
    setFilteredTasks(filteredTasks);
  }, [searchTerm, tasks]);

  //Function to handle set filters
  const handleSetFilters = () => {
    if (!status && !category && !priority) {
      toast("No filters applied");
    } else {
      setIsFiltersApplied(!isFiltersApplied);
    }
    setOpenFilterDropDown(false);
  };

  //Pagination Logic
  //Function to handle page change
  const handlePageChange = (newPage) => {
    if (newPage === 0) {
      setCurrentPage(1);
    } else if (newPage > totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(newPage);
    }
  };
  const tasksPerPage = 10;
  const totalPages = Math.ceil(filteredTasks.length / tasksPerPage);

  //Finding the tasks for current page
  const currentTasks = filteredTasks?.slice(
    (currentPage - 1) * tasksPerPage,
    currentPage * tasksPerPage
  );

  return (
    <div
      className="mx-2 my-6 md:my-8"
      onClick={() => setOpenFilterDropDown(false)}
    >
      {/* All Admin-side Modals are rendered here */}

      {/* Create Task Modal */}
      {createTaskModalOpen && (
        <CreateTask
          id={userData._id}
          onClose={() => setCreateTaskModalOpen(false)}
          getAllTasks={getAllTasks}
        />
      )}

      {/* Edit Task Modal */}
      {editTaskModalOpen && (
        <EditTask
          task={selectedTask}
          id={userData._id}
          onClose={() => setEditTaskModalOpen(false)}
          getAllTasks={getAllTasks}
        />
      )}

      {/* Assign Staff Modal */}
      {assignStaffModalOpen && (
        <AssignStaff
          task={selectedTask}
          id={userData._id}
          onClose={() => setAssignStaffModalOpen(false)}
          getAllTasks={getAllTasks}
        />
      )}

      {/* View Task Updates Modal */}
      {viewTaskDetails && (
        <TaskUpdates
          task={selectedTask}
          onClose={() => setViewTaskDetails(false)}
        />
      )}

      {/* Delete Confirmaton Modal */}
      {deleteModalOpen && (
        <ConfirmDeleteModal
          item="task"
          deleteFunction={() => deleteTask(selectedTask._id)}
          onClose={() => setdeleteModalOpen(false)}
        />
      )}

      {/* -----------------------------------------------------------*/}

      {/* All Staff-side modals are rendered here */}

      {/* Start Task Modal */}
      {startTaskModalOpen && (
        <StartTask
          task={selectedTask}
          id={userData._id}
          onClose={() => setStartTaskModalOpen(false)}
          getAllTasks={getAllTasks}
        />
      )}

      {/* End Task Modal */}
      {endTaskModalOpen && (
        <EndTask
          task={selectedTask}
          id={userData._id}
          onClose={() => setEndTaskModalOpen(false)}
          getAllTasks={getAllTasks}
        />
      )}

      <div className="relative flex items-center justify-between ">
        {/* Filter Dropdown */}
        {openFilterDropDown && (
          <div
            className="absolute right-0 top-36 z-50 rounded-lg border border-gray-200 bg-white p-4 text-sm shadow-lg md:top-28 "
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-wrap gap-6 md:flex-row md:justify-between">
              {/* Filtering using Status */}
              <div className="flex flex-col gap-1 font-medium tracking-wide">
                <h2 className="mb-1 text-sm font-semibold tracking-wide text-primaryText">
                  SELECT STATUS
                </h2>
                <label htmlFor="" className="flex items-center gap-1">
                  <input
                    type="radio"
                    value="Pending"
                    checked={status === "Pending"}
                    onChange={(e) => setStatus(e.target.value)}
                  />
                  Pending
                </label>

                <label htmlFor="" className="flex items-center gap-1 ">
                  <input
                    type="radio"
                    value="Ongoing"
                    checked={status === "Ongoing"}
                    onChange={(e) => setStatus(e.target.value)}
                  />
                  Ongoing
                </label>

                <label htmlFor="" className="flex items-center gap-1">
                  <input
                    type="radio"
                    value="Completed"
                    checked={status === "Completed"}
                    onChange={(e) => setStatus(e.target.value)}
                  />
                  Completed
                </label>
              </div>

              {/* Filtering using Priority */}
              <div className="flex flex-col gap-1 font-medium tracking-wide">
                <h2 className="mb-1 font-semibold tracking-wide text-primaryText">
                  SELECT PRIORITY
                </h2>
                <label htmlFor="" className="flex items-center gap-1 ">
                  <input
                    type="radio"
                    value="High"
                    checked={priority === "High"}
                    className=" text-indigo-500 "
                    onChange={(e) => setPriority(e.target.value)}
                  />
                  High
                </label>

                <label htmlFor="" className="flex items-center gap-1 ">
                  <input
                    type="radio"
                    className="text-sm"
                    value="Medium"
                    checked={priority === "Medium"}
                    onChange={(e) => setPriority(e.target.value)}
                  />
                  Medium
                </label>

                <label htmlFor="" className="flex items-center gap-1">
                  <input
                    type="radio"
                    className="text-sm"
                    value="Low"
                    checked={priority === "Low"}
                    onChange={(e) => setPriority(e.target.value)}
                  />
                  Low
                </label>
              </div>
            </div>
            <div className="float-right flex gap-2">
              <button
                className="rounded bg-primary px-2 py-1 text-xs font-medium text-white hover:bg-hoverPrimary "
                onClick={handleSetFilters}
              >
                Apply
              </button>
            </div>
          </div>
        )}

        <h1 className="text-3xl font-bold tracking-wide text-primary ">
          Tasks
        </h1>
        {role === "admin" && (
          <button
            className="flex h-fit items-center gap-1 rounded bg-primary px-2 py-1 text-sm font-bold tracking-wide text-white hover:bg-hoverPrimary"
            onClick={() => setCreateTaskModalOpen(true)}
          >
            Create Task <BsListTask size={14} />
          </button>
        )}
      </div>

      <div className="my-6 flex flex-col gap-4">
        {/* Search Bar and Filters */}
        <div className="relative flex flex-col justify-between gap-2 md:flex-row md:items-center">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[100%] rounded-lg border border-gray-300 p-2 pl-8 pr-10 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
          />
          <FaSearch className="absolute left-2 top-5 -translate-y-1/2 transform text-primary md:left-2 md:top-1/2" />
          <div>
            <select
              name="category"
              id=""
              onChange={(e) => setCategory(e.target.value)}
              className="w-[100%] rounded-lg border border-gray-300 p-2 pl-8 pr-10 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
            >
              <option value="">Select Category</option>
              {allCategories?.length > 0 ? (
                allCategories?.map((category, index) => (
                  <option value={category._id} key={index}>
                    {category.name}
                  </option>
                ))
              ) : (
                <option value="">No Categories available</option>
              )}
            </select>
          </div>
          {/* Start Date  */}
          <div className="flex flex-col gap-2 md:flex-row">
            <div className="flex flex-col">
              <label
                htmlFor="startDate"
                className=" text-xs font-semibold tracking-wide text-primaryText"
              >
                Start Date
              </label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className=" rounded-lg border border-gray-300 p-2 text-primaryText focus:outline-none focus:ring-1 focus:ring-blue-400 lg:w-auto"
              />
            </div>
          </div>

          {/* Filter Button */}
          <button
            className="text-md float-right flex w-1/3 items-center gap-2 rounded-lg bg-gray-100 px-2 py-1 tracking-wide text-primaryText md:float-none md:w-auto md:px-5 md:py-2 md:text-lg"
            onClick={(e) => {
              e.stopPropagation();
              toggleFilterDropDown();
            }}
          >
            <FaFilter className="text-primary" /> Filter
            <RiArrowDownSLine />
          </button>

          {/* Clear Filters button */}
          {(status || category || priority || startDate || searchTerm) && (
            <button
              className="absolute -right-6  w-fit rounded-lg px-2 py-1 font-bold text-red-500"
              title="Clear Filters"
              onClick={clearFilters}
            >
              x
            </button>
          )}
        </div>

        {/* Tasks Table Goes Here */}
        <div className="min-h-[70vh] overflow-x-auto">
          <table className="min-w-full overflow-y-visible rounded-md border-blue-200 ">
            {/* Table Head */}
            <thead>
              <tr className="bg-blue-50">
                <th className="rounded-tl-xl px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Sl
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Name
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Contact
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Category
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Priority
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Location
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Site
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Description
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  StartDate
                </th>

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Time
                </th>

                {role === "admin" && (
                  <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                    Status
                  </th>
                )}

                {role === "admin" && (
                  <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                    Assigned Staff
                  </th>
                )}

                <th className="px-6 py-3 text-left text-[14px] font-semibold text-primaryText">
                  Actions
                </th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className="text-[13px] font-medium tracking-wide text-[#202224]">
              {loading ? (
                //Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="animate-pulse border-b border-gray-200"
                  >
                    <td className="px-6 py-4">
                      <div className="h-4  w-3/4 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4 w-1/2 rounded bg-skeletonLoaderColor "></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-2/3 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-2/3 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-2/3 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-full rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4 w-full rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4  w-full rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4 w-1/2 rounded bg-skeletonLoaderColor"></div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="h-4 w-1/2 rounded bg-skeletonLoaderColor"></div>
                    </td>
                  </tr>
                ))
              ) : currentTasks?.length > 0 ? (
                currentTasks?.map((task, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {(currentPage - 1) * tasksPerPage + index + 1}
                    </td>

                    <td className="px-4 py-4 text-sm text-primaryText">
                      {task.name}{" "}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {task?.phone || "N/A"}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {task?.category?.name}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      <span
                        className={`font-bold   ${
                          task?.priority == "Medium" &&
                          "bg-orange-100 text-orange-700"
                        }  ${
                          task?.priority == "Low" &&
                          "bg-yellow-100 text-yellow-700"
                        }  ${
                          task?.priority == "High" && "bg-red-100 text-red-700"
                        }   rounded-lg px-4 py-2 tracking-wide`}
                      >
                        {task.priority}
                      </span>{" "}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {task.location}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {task.site ? task.site?.siteName : "N/A"}
                    </td>

                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {task.description}
                    </td>

                    <td className="relative px-1 py-4  text-sm text-primaryText">
                      {new Date(task.startDate)
                        .toLocaleDateString("en-GB")
                        .replace(/\//g, "-")}{" "}
                    </td>

                    <td className="relative px-1 py-4  text-sm text-primaryText">
                      {task.time}
                    </td>

                    {role === "admin" && (
                      <td className="relative px-6 py-4  text-xs text-primaryText">
                        <span
                          className={`flex font-bold bg-${
                            task?.status === "Pending"
                              ? "yellow-100 text-yellow-700"
                              : task?.status === "Ongoing"
                              ? "blue-100 text-blue-700"
                              : task?.status === "Completed"
                              ? "green-100 text-green-700"
                              : ""
                          }  rounded-lg px-4 py-2 tracking-wide`}
                        >
                          {task?.status}
                        </span>
                        <p className="text-md flex justify-center text-center font-medium text-primary">
                          {task.updates.duration !== 0 && (
                            <div className="mt-1 flex text-center font-medium text-primary">
                              in{" "}
                              {Math.floor(task.updates?.duration / 60) !==
                                0 && (
                                <div className="ml-1 flex text-center">
                                  {Math.floor(task.updates?.duration / 60)}{" "}
                                  Hours{" "}
                                </div>
                              )}
                              {task.updates?.duration % 60 !== 0 && (
                                <div className="ml-1">
                                  {task.updates?.duration % 60} mins
                                </div>
                              )}
                            </div>
                          )}
                        </p>
                      </td>
                    )}

                    {role === "admin" && (
                      <td className="relative px-2 py-4  text-sm text-primaryText">
                        {task?.staffAssigned?.name ||
                          (task.status === "Pending" ? (
                            <p className="text-xs italic text-gray-600">
                              No staff assigned
                            </p>
                          ) : (
                            <p className="text-xs italic text-red-500">
                              Staff might be deleted
                            </p>
                          ))}
                      </td>
                    )}

                    {/* For Admin */}
                    <td className="relative px-6 py-4  text-sm text-primaryText">
                      {role === "admin" && (
                        <div className="flex items-center gap-2">
                          {/* Task Updates Button */}
                          <button>
                            <FaRegEye
                              size={20}
                              title="Task Updates"
                              className={`font-bold text-purple-500 duration-300 hover:scale-105 hover:text-purple-800
                              `}
                              onClick={() =>
                                !task.updates?.startTime
                                  ? toast.error("No updates available")
                                  : handleViewTask(task)
                              }
                            />
                          </button>

                          {/* Edit Task Button */}
                          <button>
                            <TiEdit
                              size={24}
                              title="Edit Task"
                              className="cursor-pointer font-bold text-green-500 duration-300 hover:scale-105 hover:text-green-800"
                              onClick={() => handleEditClick(task)}
                            />
                          </button>

                          {/* Assign Staff Button */}
                          <button>
                            <MdOutlineAssignmentInd
                              size={24}
                              title="Assign Staff"
                              className={`${
                                task.status === "Ongoing " ||
                                task.status === "Completed"
                                  ? "cursor-not-allowed"
                                  : "cursor-pointer"
                              } font-bold text-blue-500 duration-300 hover:scale-105 hover:text-blue-800`}
                              onClick={() =>
                                task.status === "Ongoing" ||
                                task.status === "Completed"
                                  ? toast.error(
                                      `Can't assign staff to ${task.status.toLowerCase()} task`
                                    )
                                  : handleAssignStaffClick(task)
                              }
                            />
                          </button>

                          {/* Delete Task Button */}
                          <button>
                            <MdOutlineDeleteOutline
                              size={22}
                              title="Delete Task"
                              className="cursor-pointer font-bold text-red-500 duration-300 hover:scale-105 hover:text-red-800"
                              onClick={() => handleDeleteClick(task)}
                            />
                          </button>
                        </div>
                      )}

                      {/* For Staff */}
                      {role === "staff" && (
                        <div className="flex items-center gap-2 text-xs">
                          {task?.status === "Pending" && (
                            <button
                              className="rounded bg-blue-500 px-2 py-1 text-white hover:bg-blue-800"
                              title="Start Task"
                              onClick={() => handleStartTaskClick(task)}
                            >
                              Start
                            </button>
                          )}

                          {task?.status === "Ongoing" && (
                            <button
                              className="rounded bg-red-500 px-2 py-1 text-white hover:bg-red-800"
                              title="End Task"
                              onClick={() => handleEndTaskClick(task)}
                            >
                              End
                            </button>
                          )}

                          {task?.status === "Completed" && (
                            <div>
                              <button
                                className="mb-1 cursor-not-allowed rounded bg-green-500 px-2 py-1 text-white"
                                title="Task Finished"
                              >
                                Finished
                              </button>
                              <p className="text-md text-center font-medium text-primary">
                                {task.updates.duration !== 0 && (
                                  <p className="mt-1 flex text-center font-medium text-primary">
                                    <span className="mr-1">in </span>
                                    {Math.floor(task.updates?.duration / 60) !==
                                      0 && (
                                      <span>
                                        {Math.floor(
                                          task.updates?.duration / 60
                                        )}{" "}
                                        Hours
                                      </span>
                                    )}
                                    {task.updates?.duration % 60 !== 0 && (
                                      <span>
                                        {task.updates?.duration % 60} Mins
                                      </span>
                                    )}{" "}
                                  </p>
                                )}
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={12}
                    className="px-6 py-40 text-center text-lg text-gray-600"
                  >
                    No Tasks Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="float-right my-4 flex items-center justify-end gap-2 font-medium">
          <span className="text-sm text-primaryText">
            {currentPage} - {totalPages} pages
          </span>
          <div className="flex  items-center gap-2">
            <button
              className={`cursor-pointer rounded font-bold  ${
                currentPage === 1
                  ? "text-gray-300 hover:text-gray-300"
                  : "text-primary hover:text-hoverPrimary"
              }`}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              <IoIosArrowDropleft size={24} />
            </button>

            <button
              className={`cursor-pointer rounded font-bold  ${
                currentPage === totalPages
                  ? "text-gray-300 hover:text-gray-300"
                  : "text-primary hover:text-hoverPrimary"
              }`}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              <IoIosArrowDropright size={24} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Task;
